const HAS_LETTER_OR_NUMBER = /[\p{L}\p{N}]/u;

const validateClientId = (value) => {
    const text = typeof value === "string" ? value.trim() : "";
    if (!text) return "Client ID is required.";
    if (text.includes("#")) return 'Client ID cannot contain "#".';
    return "";
};

const validateClientName = (value) => {
    const text = typeof value === "string" ? value.trim() : "";
    if (!text) return "Client Name is required.";
    if (!HAS_LETTER_OR_NUMBER.test(text)) return "Client Name must contain a letter or number.";
    return "";
};

const validateClientForm = (values, { requireClientId = false } = {}) => {
    const errors = {};
    if (requireClientId) {
        const clientIdError = validateClientId(values.clientId);
        if (clientIdError) errors.clientId = clientIdError;
    }
    const nameError = validateClientName(values.displayName);
    if (nameError) errors.displayName = nameError;
    return errors;
};

const buildCreateBody = ({ clientId, displayName, groupId, status }) => {
    const body = {
        clientId: clientId.trim(),
        displayName,
        status,
    };
    const group = typeof groupId === "string" ? groupId.trim() : "";
    if (group) body.groupId = group;
    return body;
};

const buildUpdateBody = ({ displayName, groupId, status }) => ({
    displayName,
    groupId: typeof groupId === "string" && groupId.trim() ? groupId.trim() : null,
    status,
});

export { validateClientForm, validateClientId, validateClientName, buildCreateBody, buildUpdateBody };
